module.exports = __webpack_public_path__ + "aa2713963b98c51113298798f8f1ba3b.svg";